import { createSlice } from '@reduxjs/toolkit';

const normalizeDevise = (value) => {
  if (typeof value === 'string' && value && value !== '---') {
    return value;
  }
  if (value && typeof value === 'object' && typeof value.devise === 'string') {
    return value.devise;
  }
  return 'TND';
};

const readStoredDevise = () => {
  try {
    const raw = localStorage.getItem('deviseInfo');
    if (!raw) return 'TND';
    return normalizeDevise(JSON.parse(raw));
  } catch {
    return 'TND';
  }
};

const initialState = {
  deviseInfo: readStoredDevise(),
};

const deviseSlice = createSlice({
  name: 'devise',
  initialState,
  reducers: {
    setCredentialDevise: (state, action) => {
      const next = normalizeDevise(action.payload);
      state.deviseInfo = next;
      localStorage.setItem('deviseInfo', JSON.stringify(next));
    },
  },
});

export const { setCredentialDevise } = deviseSlice.actions;

export default deviseSlice.reducer;
